document.addEventListener('DOMContentLoaded', function() {
function equalizeColumnHeights() {
    const gallery = document.querySelector('.product-gallery');
    const info = document.querySelector('.product-info');
    if (info && gallery) {
      gallery.style.maxHeight = `${info.scrollHeight}px`;
    }
  }

  equalizeColumnHeights();
  window.addEventListener('load', equalizeColumnHeights);
  window.addEventListener('resize', equalizeColumnHeights);
});
